import React, { Suspense } from 'react';
import { createRoot } from "react-dom/client";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { ThemeProvider } from 'styled-components';
import { App } from './App';
import { theme } from './styled/theme';
import reportWebVitals from './reportWebVitals';
import { FUNCTIONS_URL } from './firebase';

const client = new ApolloClient({
	uri: `${FUNCTIONS_URL}/graphql`,
	cache: new InMemoryCache({ addTypename: false }),
});


//TODO revert StrictMode
createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<ApolloProvider client={client}>
			<ThemeProvider theme={theme}>
				<Suspense fallback={'loading...'}>
					<App />
				</Suspense>
			</ThemeProvider>
		</ApolloProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
